module.exports = __webpack_public_path__ + "img/156.49db7a46.jpg";